
export default {
  styleOverrides: {  
    root: {
      padding: '0'
    },
    spacing: {
      padding: '8px 24px 24px'
    }
  },    
};
